import { FaArrowUpRightFromSquare } from "react-icons/fa6";
import { ExternalLinkProps } from "./ExternalLink.definition";

import "./ExternalLink.scss";

const ExternalLink = (props: ExternalLinkProps): JSX.Element => {
  const Icon = FaArrowUpRightFromSquare as unknown as React.FC;
  return (
    <a className="externalLink" href={props.url} target="_blank">
      {props.label}
      <Icon />
    </a>
  );
};

export default ExternalLink;
